import Model from '@/models/Model';
import api from '@/services/Api';

export default class Contract extends Model {
    get route () {
        return 'contracts';
    }

    static get className () {
        return 'Contract';
    }

    buy (prepaidCardId) {
        return api.post(`${this.route}/${this[this.primaryKey]}/buy`, {
            prepaid_card_id: prepaidCardId,
        });
    }
}
